// extracted by mini-css-extract-plugin
module.exports = {"JoinOrCreateTeamViewTitle":"JoinOrCreateTeamView_JoinOrCreateTeamViewTitle__IsQDK"};